import React, { useEffect, useState } from 'react';
import InfinityLoader from '../dropdownSearch/infinityLoader';
import API from '../../services/api';
import utils from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedProject } from '../../redux/projects/actions';
import {
  getSelectedAnalyticsDashboard,
  getSelectedSummaryDashboard,
  selectSummaryDashboard,
  selectAnalyticsDashboard,
  getSelectedCampaignDashboard
} from '../../redux/templates/actions';
import { getUser } from '../../redux/user/actions';
// import { setAlert } from '../../redux/dashboard/actions';
// import types from '../../redux/types';
// import { getSelectedCompany } from '../../redux/company/actions';

const DashboardSelector = ({ collection = 'SUMMARY' }) => {
  const [currentDashboards, setCurrentDashboards] = useState([]);
  const [selectedOption, setSelectedOption] = useState({ label: 'Select Template' });
  const [datasources, setDatasources] = useState([]);
  const [currentFilter, setCurrentFilter] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [datasourceIsEmpty, setDatasourceIsEmpty] = useState(false);

  const siteGroup = useSelector(getSelectedProject);
  const selectedDashboard = useSelector(getSelectedSummaryDashboard);
  const selectedAnalyticsDashboard = useSelector(getSelectedAnalyticsDashboard);
  const selectedCampaignDashboard = useSelector(getSelectedCampaignDashboard);
  const user = useSelector(getUser);
  const project = useSelector(getSelectedProject);

  const dispatch = useDispatch();

  useEffect(() => {
    if (siteGroup) {
      API.getDatasources(siteGroup.id).then(res => {
        if (res.datasources.length === 0) {
          setDatasourceIsEmpty(true);
        } else {
          setDatasourceIsEmpty(false);
          setDatasources(res.datasources);
        }
      });
    }
  }, [siteGroup]);

  useEffect(() => {
    if (isOpen) {
      loadMoreItems();
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedDashboard && collection === 'SUMMARY') {
      setSelectedOption({
        label: selectedDashboard.displayName ? selectedDashboard.displayName : selectedDashboard.id
      });
    }
  }, [selectedDashboard]);

  useEffect(() => {
    if (selectedAnalyticsDashboard && collection === 'ANALYTICS') {
      setSelectedOption({
        label: selectedAnalyticsDashboard.displayName
          ? selectedAnalyticsDashboard.displayName
          : selectedAnalyticsDashboard.id
      });
    }
  }, [selectedAnalyticsDashboard]);

  useEffect(() => {
    if (selectedCampaignDashboard && collection === 'CAMPAIGN') {
      setSelectedOption({
        label: selectedCampaignDashboard.displayName
          ? selectedCampaignDashboard.displayName
          : selectedCampaignDashboard.id
      });
    }
  }, [selectedCampaignDashboard]);

  const getQueryFromDataSource = datasource => {
    return `compatibleDatasources = ['${datasource}']`;
  };

  const getFilters = searchBy => {
    if (datasourceIsEmpty) {
      return `(compatibleDatasources = ['AUDIENCE_M'] OR compatibleDatasources = ['TRAFFIC_M']) AND (collection = "${collection}" AND enabled = true)`;
    }

    const filterList = datasources.map(getQueryFromDataSource);
    const isVehicleCrowd =
      datasources.some(datasource => datasource === 'AUDIENCE_M') &&
      datasources.some(datasource => datasource === 'TRAFFIC_M');

    const isRetail =
      datasources.some(datasource => datasource === 'MOBILE_M') &&
      datasources.some(datasource => datasource === 'AUDIENCE_M');

    if (isVehicleCrowd) {
      filterList.push(`compatibleDatasources = ['TRAFFIC_M','AUDIENCE_M']`);
    }

    if (isRetail) {
      filterList.push(`compatibleDatasources = ['AUDIENCE_M','MOBILE_M']`);
    }

    const filterQuery = datasources.length > 0 ? filterList.join(' OR ') : '';
    const searchQuery = searchBy !== '' ? `(id ILIKE "%${searchBy}%" OR displayName ILIKE "%${searchBy}%")` : '';

    return `${searchQuery !== '' ? `${searchQuery} AND ` : ''}${
      filterQuery !== '' ? `(${filterQuery}) AND ` : ''
    }(collection = '${collection}' AND enabled = true)`;
  };

  const loadMoreItems = (nextPageToken = '', searchingBy = '') => {
    const query = encodeURI(getFilters(searchingBy));
    const filter = query !== '' ? query : '';

    if (filter !== currentFilter) {
      setCurrentDashboards([]);
    }

    return API.getTemplates(nextPageToken, filter).then(res => {
      const templateVersions = res.templates.map(template => ({
        label: template.displayName ? template.displayName : template.id,
        value: `"${template.id}"`,
        data: template
      }));

      const visionTemplates = templateVersions.filter(template => template.data.isCms === false);
      const integrationsTemplates = templateVersions.filter(
        template =>
          template.data.isCms === true && project.enabledCmsIntegrations?.includes(template.data.cmsId.toUpperCase())
      );

      const fetchedVersions = [...visionTemplates, ...integrationsTemplates];

      // Reset list when filter changes
      if (filter !== currentFilter) {
        setCurrentFilter(filter);
        setCurrentDashboards(fetchedVersions);
      } else {
        const newVersions = utils.mergeArraysByField(fetchedVersions, currentDashboards, 'value');
        setCurrentDashboards(newVersions);
      }

      return res.nextPageToken;
    });
  };

  const onSelect = selectedValue => {
    const selected = currentDashboards.find(dashboard => dashboard.value === selectedValue);
    const userPreferences = utils.deepClone(user.preferences);
    // const customWidgets = utils.deepClone(userPreferences.customWidgets);
    delete userPreferences.customWidgets;
    if (collection === 'SUMMARY') {
      userPreferences.defaultSummaryDashboard = selected.data.id;
      dispatch(selectSummaryDashboard(selected.data));
    } else {
      userPreferences.defaultAnalyticsDashboard = selected.data.id;
      dispatch(selectAnalyticsDashboard(selected.data));
    }

    // try {
    //   API.updateCurrentUser({ preferences: { ...userPreferences } }, ['preferences']);
    //   dispatch({
    //     type: types.UPDATE_USER,
    //     payload: { ...user, preferences: { ...userPreferences, customWidgets } }
    //   });
    // } catch (error) {
    //   dispatch(setAlert(utils.generateAlert(error.message, 'error')));
    // }
  };

  return (
    <div className="version-selector">
      <InfinityLoader
        title={'Search Version'}
        leftAlign
        outline={false}
        selected={selectedOption}
        label={'Dashboard'}
        onSelect={selectedValue => onSelect(selectedValue)}
        onLoading={loadMoreItems}
        onOpenChange={setIsOpen}
        totalSize={9999}
        options={currentDashboards}
      />
    </div>
  );
};

export default DashboardSelector;
